import { RouteConfig } from "vue-router";

const visualizacionPagos: RouteConfig = {
  path: "/visualizacionPagos",
  name: "visualizacionPagos",
  component: () => import(/* webpackChunkName: "visualizacion-pagos" */ "@/views/VisualizacionPagos.vue"),
};

export default visualizacionPagos;
